import { ActForm, User, SignatureState } from '@builddocs/data-management'
import { UUID } from '@builddocs/data-management'
import { WorkDocSection } from '@builddocs/data-management-rest'
import { SecondaryActType } from '@builddocs/filestore-api'
import { AOSRType } from '@builddocs/filestore-api'
import {
  getDigestAndPrepareAOSR,
  getDigestAndPrepareSecondaryAct,
  getBlobAOSR,
} from '@builddocs/filestore-api'

type PrepareDataType = {
  isEmbedded: boolean
  user: User
  act: AOSRType | SecondaryActType
  projectId: UUID
  contractId: UUID
  selectedWorkDocSection?: WorkDocSection
  selectedSigners: UUID[]
  imprint: string
  keyIssuer: string
  certificateDateStart: string
  certificateDateEnd: string
  signerName: string
  facePhoto: string
  keySerialNumber: string
  withPoa?: boolean
  poaId?: string | null
  poaDateStart?: string | null
  poaDateEnd?: string | null
}

type PrepareDataResponse = {
  hash: string
  actRegistryDigest?: string
  currentSignatureBase64?: string
}

export const prepareDataForSigningNew = async ({
  user,
  act,
  imprint,
  keyIssuer,
  certificateDateStart,
  certificateDateEnd,
  signerName,
  facePhoto,
  keySerialNumber,
  withPoa,
  poaId,
  poaDateStart,
  poaDateEnd,
}: PrepareDataType): Promise<PrepareDataResponse> => {
  const isAosr = act.actType === ActForm.AOSR

  if (isAosr) {
    let digest: string
    let actRegistryDigest: string | undefined

    if (act.signatureEmbedded) {
      const aosrDigestResponse = await getDigestAndPrepareAOSR({
        base64signature: null,
        documentId: act.id,
        employmentId: user.employment.employmentId,
        imprint: imprint,
        keyIssuer: keyIssuer,
        signatureState: SignatureState.PENDING,
        certificateDateStart,
        certificateDateEnd,
        name: signerName,
        faceId: {
          faceImage: facePhoto,
          keySerialNumber,
        },
        withPoa,
        poaId,
        poaDateStart,
        poaDateEnd,
      })

      digest = aosrDigestResponse.digest
      actRegistryDigest = aosrDigestResponse.actRegistryDigest
    } else {
      digest = await getBlobAOSR(act.id)
    }

    return {
      hash: digest,
      actRegistryDigest,
      currentSignatureBase64: act.base64signature,
    }
  } else {
    const secondaryDigestResponse = await getDigestAndPrepareSecondaryAct({
      base64signature: null,
      documentId: act.id,
      employmentId: user.employment.employmentId,
      imprint: imprint,
      keyIssuer: keyIssuer,
      signatureState: SignatureState.PENDING,
      certificateDateStart,
      certificateDateEnd,
      name: signerName,
      faceId: {
        faceImage: facePhoto,
        keySerialNumber,
      },
      withPoa,
      poaId,
      poaDateStart,
      poaDateEnd,
    })

    return {
      hash: secondaryDigestResponse.digest,
      actRegistryDigest: secondaryDigestResponse.actRegistryDigest,
      currentSignatureBase64: act.base64signature,
    }
  }
}
